export default "__VITE_ASSET__CLi$Qx1t__"